<mat-toolbar>
  <span translate>NETWORKS</span>
  <span class="toolbar-spacer"></span>
  <button mat-raised-button routerLink="/networks/new">
    <span translate>NEW_NETWORK</span>
  </button>
</mat-toolbar>


<div class="row mt-3">
  <div class="col-md-12">
    <mat-form-field class="w-100">
      <mat-label translate>SEARCH</mat-label>
      <input type="text" matInput [(ngModel)]="searchText"  (keyup)="applyFilter()">
      @if (searchText) {
        <button mat-icon-button color="primary" matSuffix (click)="$event.stopPropagation();searchText = null;applyFilter();"><mat-icon>close</mat-icon></button>
      }
    </mat-form-field>
  </div>
</div>
<div class="row">
  <div class="col-md-12">
    <table mat-table [dataSource]="dataSource" matSort class="w-100">
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
        <td mat-cell *matCellDef="let element"> {{element.id}} </td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header translate>NAME</th>
        <td mat-cell *matCellDef="let element"> {{element.name}} </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef ></th>
        <td mat-cell *matCellDef="let element">
          <button type="button" mat-icon-button color="primary" [routerLink]='["/networks/"+element.id]'><mat-icon>edit</mat-icon></button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    @if (companies.length === 0) {
      <div class="d-block text-center bg-white p-3" translate>NO_DATA</div>
    }
    <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
  </div>
</div>
